import React, { useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import classNames from 'classnames';

import { useDocsPageContext } from '../../../hooks/useDocsPageContext';
import { useResponsiveBreakpoints } from '../../../hooks/useResponsiveBreakpoints';

import { startChatWithDocs } from '../../../helpers/assistantUtils';
import { handleDuplicateItem } from '../../../helpers/docsUtils';

import { CONTENT_TYPE } from '../../../constants/docs';

import MobilePopup from '../../../design-system/MobilePopup/MobilePopup';
import { ListOption, ListOptionGroup } from '../../../design-system';

const DocCardMoreOptionsPopup = ({
    contentType,
    data,
    setActionModal,
    setErrorAlert,
    setSuccessAlert,
    onNavigateToFolderView,
    parentLocation,
    position = 'right-2 top-[48px]',
    width = 300,
    onClose,
}) => {
    const [searchParams] = useSearchParams();

    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const { setSidePanelFolders, requestKeysToMutate, currentRequestKeyToMutate } =
        useDocsPageContext();

    const { isMobile } = useResponsiveBreakpoints();

    const openModal = (action) => {
        let updatedData = { ...data, parentLocation };
        if (action === 'move') {
            updatedData.content_type = contentType;
        }

        setActionModal({ action, data: updatedData, contentType });
        onClose();
    };

    const handleClose = (e) => {
        e?.stopPropagation();
        e?.preventDefault();
        onClose();
    };

    const handleDuplicate = async () => {
        await handleDuplicateItem({
            id: data.id,
            location,
            setSuccessAlert,
            setErrorAlert,
            setIsLoading,
            closePopup: handleClose,
            requestKeysToMutate,
            contentType,
            onNavigateToFolderView,
            parentLocation,
            setSidePanelFolders,
            currentRequestKeyToMutate,
            skipUpdatingSidePanel: searchParams.get('search'),
        });
    };

    const isDocument = contentType !== CONTENT_TYPE.folder;

    const listOptions = (
        <>
            <ListOption
                leadingIconName="editLineIcon"
                text="Rename"
                onClick={() => openModal('rename')}
            />
            <ListOption
                leadingIconName="copyIcon"
                text="Duplicate"
                isLoading={isLoading}
                onClick={handleDuplicate}
            />
            <ListOption
                leadingIconName="folderTransferFillIcon"
                text="Move to"
                onClick={() => openModal('move')}
            />
            <ListOption
                leadingIconName="inboxArchiveLineIcon"
                text="Archive"
                onClick={() => openModal('archive')}
            />
            <ListOption
                leadingIconName="userSharedLineIcon"
                text="Send to"
                onClick={() => openModal('send')}
            />

            {isDocument && (
                <ListOption
                    leadingIconName="robot2LineIcon"
                    text="Chat with doc"
                    onClick={() => startChatWithDocs({ navigate, idsArray: [data.id] })}
                />
            )}
        </>
    );

    if (isMobile) {
        return (
            <MobilePopup onClose={handleClose} closeButtonText="Cancel">
                {listOptions}
            </MobilePopup>
        );
    }

    const popupClassName = classNames(
        'absolute z-20 pb-5',
        typeof position === 'string' && (position || 'right-2 top-[48px])')
    );

    let style = {};
    if (typeof position === 'object' && position !== null) {
        style = { ...position };
    }

    return (
        <div className={popupClassName} style={style} onClick={(e) => e.preventDefault()}>
            <ListOptionGroup
                fixedWidth={width || 300}
                listOptions={listOptions}
                handleClose={handleClose}
            />
        </div>
    );
};
export default DocCardMoreOptionsPopup;
